.restoreButton {
  margin-top: 16px;
}

.divider {
  margin-top: 16px;
}
